import { render } from "./AssistantChat.vue?vue&type=template&id=0de38f64&scoped=true"
import script from "./AssistantChat.vue?vue&type=script&lang=js"
export * from "./AssistantChat.vue?vue&type=script&lang=js"

import "./AssistantChat.vue?vue&type=style&index=0&id=0de38f64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de38f64"]])

export default __exports__